import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import TalentSuggestionCard from './TalentSuggestionCard'

/**
 * Organism Component: TalentSuggestionsSection
 * Displays suggested talents and new talent invitation option
 */
const TalentSuggestionsSection = ({
  suggestedTalents = [],
  onTalentAdd,
  onNewTalentAdd,
  hasCompletedOnboarding,
  selectedTalents = []
}) => {
  const { t } = useTranslation()
  return (
    <div className='mt-6 rounded-lg border border-lightGrey p-4'>
      <span className='text-xs font-semibold uppercase text-gray-500'>
        {t('discover.invite_talent_modal.suggested_talents_title')}
      </span>

      {/* Suggested Talents */}
      {suggestedTalents.map((talent, index) => (
        <div key={talent.id}>
          <TalentSuggestionCard
            talent={talent}
            onAdd={onTalentAdd}
            className='mt-4'
            isAdded={selectedTalents.some((t) => t.id === talent.id)}
          />
          {index < suggestedTalents.length - 1 && (
            <div className='h-px w-full bg-gray-200' />
          )}
        </div>
      ))}

      {/* {suggestedTalents.length > 0 && (
        <div className='h-px w-full bg-gray-200' />
      )} */}

      {/* New Talent Section */}
      {/* {hasCompletedOnboarding && (
        <div className='relative mt-4 overflow-hidden rounded-lg border-2 border-dashed border-lightBlue bg-[#EBEFFD66] pb-6 pl-4 pr-4 pt-6'>
          <div className='flex flex-row items-start justify-between'>
            <div>
              <Heading level={4}>
                {t('discover.invite_talent_modal.new_talent_title')}
              </Heading>
              <div className='max-w-56 text-sm font-normal text-rockGrey'>
                {t('discover.invite_talent_modal.new_talent_description')}
              </div>
            </div>
            <Button.SecondaryXL
              text={t('discover.invite_talent_modal.add')}
              icon={<PlusIcon className='size-4 text-buttonSecondaryBlue' />}
              onClick={onNewTalentAdd}
            />
          </div>
          <Image
            height={111}
            width={187}
            src={Illustration}
            outerClassName='absolute right-14 -bottom-2'
          />
        </div>
      )} */}
    </div>
  )
}

TalentSuggestionsSection.propTypes = {
  suggestedTalents: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      email: PropTypes.string.isRequired,
      type: PropTypes.string
    })
  ),
  onTalentAdd: PropTypes.func.isRequired,
  onNewTalentAdd: PropTypes.func.isRequired,
  hasCompletedOnboarding: PropTypes.bool,
  selectedTalents: PropTypes.array
}

export default TalentSuggestionsSection
